import router from '@/router';
import { getCookie, setCookie, deleteCookie } from "./cookies";
import { AppConfig } from "./variables";

// TODO: Use localStorage instead

export function getToken() {
  const cookie = getCookie("user_token");
  return cookie;
}
export function getRefreshToken() {
  const cookie = getCookie("user_refresh_token");
  return cookie;
}

export function setToken(token) {
  const accessToken = token.accessToken
  const refreshToken = token.refreshToken

  if (accessToken)
    setCookie("user_token", accessToken);

  if (refreshToken)
    setCookie("user_refresh_token", refreshToken);
}

export function deleteToken() {
  deleteCookie("user_token");
  deleteCookie("user_refresh_token");
}

export function authTokenExists() {
  return !!this.getToken();
}

export function decodeToken(token = getToken()) {
  if (token) return JSON.parse(atob(token.split(".")[1]));
  return false;
}

export function getProductPrimaryImage(product) {
  if (product.images) {
    const image = product.images.find(image => image.isPrimary === true)
    if (image) {
      return image.url
    }
  }
  
  return product.image ?? AppConfig.defaults.product_image
}

export function buildLoginRedirect(to = {}) {
  const currentRoute = router.history.current

  return {
    name: "Login",
    params: { invalidToken: true },
    query: { to: to.path ?? currentRoute.path },
  }
}

export default {
  getToken,
  getRefreshToken,
  setToken,
  deleteToken,
  authTokenExists,
  getProductPrimaryImage,
  buildLoginRedirect,
};
